
import { defineComponent, PropType } from 'vue'
import { ElForm } from 'element-plus'
import { MESSAGE_TYPE_CONFIRM, addMessageQueue } from '@/plugins/messageQueue'
import JrButton from '@/components/jr-parts/JrButton.vue'
import MessageService from '@/services/message'
import { WitnessScheduleUpdate } from '@/requests/boundary'
import { ScheduleDecideForm } from '@/types/forms'

/**
 * 現地立会日程保存ボタン
 */
export default defineComponent({
  name: 'BoundaryWitnessScheduleDecide',
  emits: ['sent'],
  components: {
    JrButton,
  },
  props: {
    boundaryId: {
      type: Number,
      required: true,
    },
    data: {
      type: Object as PropType<ScheduleDecideForm>,
      required: true,
    },
    formRef: {
      type: Object as PropType<InstanceType<typeof ElForm>>,
      required: false,
      default: null,
    },
  },
  setup(props, context) {
    const decide = async () => {
      if (!props.formRef) {
        return
      }
      props.formRef.validate((valid) => {
        if (!valid) {
          // バリデーションNG
          return
        }

        // 確認メッセージ追加
        addMessageQueue(MESSAGE_TYPE_CONFIRM, MessageService.codes.CONFIRM_SAVE, async () => {
          // 送信する
          //safari対応のためYYYY/MM/DD HH:mm:ss形式に変更したのを
          //APIリクエスト用にYYYY-MM-DD HH:mm:ss形式に変更
          let dateTime: string | null = null
          if (props.data.date_time !== null) {
            dateTime = props.data.date_time.replace(/\//g, '-')
          }
          const request = new WitnessScheduleUpdate(props.boundaryId, dateTime as string)
          if (await request.exec()) {
            context.emit('sent')
          }
        })
      })
    }

    return {
      decide,
    }
  },
})
